import { SITE } from '@/config/site';

export const DEFAULT_LANGUAGE = SITE.defaultLanguage;

const FLAG = 'https://flagcdn.com/w40';

/** Languages shown in Settings */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', nameKey: 'English', flag: `${FLAG}/gb.png` },
  { code: 'mm', nameKey: 'Myanmar', flag: `${FLAG}/mm.png` },
  { code: 'ms', nameKey: 'Malay', flag: `${FLAG}/my.png` },
];

export const SETTING_LANGUAGES = SUPPORTED_LANGUAGES;

export function normalizeLanguage(lang) {
  const code = String(lang || '').toLowerCase();
  if (['en', 'mm', 'ms'].includes(code)) {
    return code;
  }
  return DEFAULT_LANGUAGE;
}
